import { SiteDescription as LibsSiteDescription } from '@lifedot/components/SiteDescription'
import { useDescription } from './dependencies'

export const SiteDescription = () => {
  const description = useDescription()

  return <LibsSiteDescription description={description} />
}
